import { createI18n } from 'vue-i18n'

import messages from '../locales'

import { mergeLibraryLocales } from './libraryLocales'

export const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || import.meta.env.VITE_DEFAULT_LANG,
  fallbackLocale: 'en-US',
  messages
})

mergeLibraryLocales(i18n.global)
